import * as importedChip from "@interstate/components/Chip";
import type { LinkChipProps } from "@interstate/components/Chip";
import type { coreEventProperties } from "@dealer-center/core-interfaces-third-party-gtm";
import { TagManager } from "@dealer-center/core-third-party-gtm";

export interface LinkChipInterface extends LinkChipProps {
  analyticsConfiguration: {
    eventName: string;
    eventProperties?: coreEventProperties;
  };
}

export const LinkChip = ({
  onClick,
  analyticsConfiguration,
  ...props
}: LinkChipInterface) => {
  return (
    <importedChip.LinkChip
      {...props}
      onClick={interstateEvent => {
        if (analyticsConfiguration) {
          TagManager.event({
            eventName: analyticsConfiguration.eventName,
            eventProperties: analyticsConfiguration.eventProperties
          });
        }
        if (onClick) {
          onClick(interstateEvent);
        }
      }}
    />
  );
};
